<template>
  <div>
    <Navigation />
    <div class="content mt-4">
      <div class="container content--demo-detail">
        <div class="row">
          <div class="col-12 mt-5">
            <div>
              <div class="page-block--title">Demo by {{ demo.artist_name }}</div>
            </div>
            <hr style="border-color: gray;" />

          </div>
          <div class="col-xs-12 col-sm-12 col-lg-6 mt-2">
               
              <div><strong>Artist</strong> {{ demo.artist_name }}</div>
              <div><strong>Track</strong> {{ demo.track_name }}</div>
              <div class="page--link"><strong>Email</strong> <span  class="page--url"><a :href="'mailto:' + demo.artist_email" target="_blank">
                {{ demo.artist_email
                }}<svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  height="11px"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-external-link"
                >
                  <path
                    d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                  ></path>
                  <polyline points="15 3 21 3 21 9"></polyline>
                  <line x1="10" y1="14" x2="21" y2="3"></line>
                </svg>
                </a></span></div>
                
              <div><strong>Submitted </strong>                 <span v-if="getDemoDate(demo.created_at) == 'Today'"><strong>{{ getDemoDate(demo.created_at) }}</strong></span>
              <span v-else>{{ getDemoDate(demo.created_at) }}</span></div>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-6 mt-2">
            <div class="block--content-item player--audio"  style="width: 100%">
              <div class="demo--player" style="width: 100%">
                <NativePlayer v-if="demo.demo_url != 'https://demobottle-storage.s3.eu-west-2.amazonaws.com/'" autoplay="false" :file="demo.demo_url"></NativePlayer>
                
                <NativePlayer v-if="demo.soundcloud_url != null" autoplay="false" :file="demo.demo_url"></NativePlayer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import NativePlayer from "../components/NativePlayer";
export default {
  name: "DemoDetail",
  components: {
    NativePlayer
  },
  methods: {
    getDemoDate(timestamp) {
      return this.timeConverter(timestamp);
    },
    timeConverter(UNIX_timestamp) {
      var a = new Date(UNIX_timestamp * 1000);
      if (!this.isToday(a)) {
        var months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        var time = date + " " + month + " " + year + " ";
        return time;
      } else {
        return "Today";
      }
    },
    isToday(someDate) {
      const today = new Date();
      return (
        someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()
      );
    },
  },
  mounted() {
    var self = this;
    this.isLoading = true;
    axios({
      method: "GET",
      crossdomain: true,
      headers: { "Content-Type": "Content-Type:application/json" },
      url: "https://api.demobottle.com/demo/" + self.demo_id,
    })
      .then(function (response) {
        self.demo = response.data;
        self.editted = self.trueCopy(self.page);
        self.isLoading = false;
      })
      .catch(function (error) {
        self.errors = error.response.data;
        self.isLoading = false;
      });
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      demo_id: this.$route.params.id,
      
      demo: {},
    };
  },
};
</script>
